import { render, staticRenderFns } from "./ContactsFragmentMobile.vue?vue&type=template&id=c3a492bc&"
import script from "./ContactsFragmentMobile.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports